import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyB3_gKqVLUW9PBoHWk-kmPo5S45AOIaGNQ",
  authDomain: "dcops-srs.firebaseapp.com",
  projectId: "dcops-srs",
  storageBucket: "dcops-srs.firebasestorage.app",
  messagingSenderId: "150067696291",
  appId: "1:150067696291:web:9dfa9a0e82da86cb616516"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
